var React = require('react');

function Search32x32 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9439 19.1206C16.3534 19.1206 19.1206 16.3534 19.1206 12.9439C19.1206 9.53434 16.3534 6.76717 12.9439 6.76717C9.53434 6.76717 6.76717 9.53434 6.76717 12.9439C6.76717 16.3534 9.53434 19.1206 12.9439 19.1206ZM21.1795 19.1206L28 25.9411L25.9411 28L19.1206 21.1795V20.0856L18.7349 19.6999C17.1907 21.0505 15.1318 21.8233 12.9439 21.8233C7.99016 21.8233 4 17.899 4 12.9439C4 7.98879 7.98879 4 12.9439 4C17.899 4 21.8233 7.98879 21.8233 12.9439C21.8233 15.1318 21.0505 17.1907 19.6999 18.7349L20.0856 19.1206H21.1795Z","fill":"black"}));
}

Search32x32.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Search32x32;

Search32x32.default = Search32x32;
